import { ENV } from '../constants.js';
import axios from 'axios';
import { getToken } from 'firebase/app-check';
import { v4 } from 'uuid';

const FUNCTION_HOST_PATHS = {
    [ENV.LOCAL]: 'http://localhost:5000/airdealer-67669/us-central1',
    // [ENV.DEVELOPMENT]: 'https://us-central1-airdealer-67669.cloudfunctions.net', // USE for deploying staging sites, need to YALC
    // [ENV.DEVELOPMENT]: 'https://ekhodealer-tony.ngrok.app/airdealer-67669/us-central1',
    [ENV.DEVELOPMENT]: 'http://localhost:5000/airdealer-67669/us-central1',
    [ENV.STAGING]: 'https://us-central1-ed-staging.cloudfunctions.net',
    [ENV.PRODUCTION]: 'https://us-central1-ad-backend-prod.cloudfunctions.net',
    [ENV.DEMO]: 'https://us-central1-ed-demo-93367.cloudfunctions.net',
};
function setFunctionHost(env) {
    return FUNCTION_HOST_PATHS[env] || FUNCTION_HOST_PATHS[ENV.LOCAL];
}
// Helper function for getting the AppCheck token
async function getAppCheckToken(appCheck) {
    try {
        const appCheckToken = await getToken(appCheck, false);
        return appCheckToken;
    }
    catch (error) {
        throw new Error(`Failed to get AppCheck token: ${error}`);
    }
}
// function that returns the correct headers for a request
function getRequestHeaders(appCheckToken, authToken) {
    // Add app check token to request headers
    const functionHeaders = { 'X-Firebase-AppCheck': appCheckToken.token };
    if (authToken) {
        functionHeaders.Authorization = `Bearer ${authToken}`;
    }
    // Generate a 32-character hexadecimal trace ID
    const traceId = v4().replace(/-/g, '');
    // Generate a 16-character hexadecimal span ID
    const spanId = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)
        .toString(16)
        .padStart(16, '0');
    // Set the sampled flag to '01' to indicate the trace should be sampled
    const traceFlags = '01';
    // Construct the traceparent header
    const traceparent = `00-${traceId}-${spanId}-${traceFlags}`;
    functionHeaders.traceparent = traceparent;
    return functionHeaders;
}
async function sendTransactionalEmail(messageData, appCheck, functionHost, messageId) {
    const body = {
        messageData,
        messageId,
    };
    try {
        const url = `${functionHost}/send_transactional_email_v2/sendTransactionalEmail`;
        let headers = {};
        try {
            const appCheckToken = await getAppCheckToken(appCheck);
            headers = getRequestHeaders(appCheckToken);
        }
        catch (appCheckError) {
            console.error('AppCheck error:', appCheckError);
            // Continue without AppCheck token
        }
        const response = await axios.post(url, body, { headers });
        console.log('sendTransactionalEmail response', response);
        if (response.status !== 200) {
            throw new Error(`Error sending transactional email. Response: ${response}`);
        }
        return response;
    }
    catch (e) {
        throw new Error(`Error sending transactional email: ${e}`);
    }
}

export { sendTransactionalEmail, setFunctionHost };
//# sourceMappingURL=serverCalls.js.map
